import React from "react";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import { useAddToPackageContext } from "./AddToPackageContext";

interface GeneratePackageButtonProps {
    buttonText: string;
    disabled?: boolean;
    successMessage?: string;
    onClick: () => void;
}

const GeneratePackageButton: React.FC<GeneratePackageButtonProps> = ({ buttonText, disabled, successMessage, onClick }) => {
    const { selectedIds } = useAddToPackageContext();

    return (
        <div className="packageResultsAction">
            {successMessage && (
                <div className="messageBox addtopackagesuccessMessage packageResultsSuccessMessage">
                    {successMessage}
                </div>
            )}
            <ActionButton
                type="button"
                buttonText={buttonText}
                buttonAction={onClick}
                disabled={Boolean(disabled) || selectedIds.length === 0}
                className="button btn-defaultPrimary packageResultsActionButton"
            />
        </div>
    );
};

export default GeneratePackageButton;
